export const USER_API_END_POINT = `${import.meta.env.VITE_LOCALHOST}/api/v1/user`;
export const JOB_API_END_POINT = `${import.meta.env.VITE_LOCALHOST}/api/v1/job`;
export const APPLICATION_API_END_POINT = `${import.meta.env.VITE_LOCALHOST}/api/v1/application`;
export const COMPANY_API_END_POINT = `${import.meta.env.VITE_LOCALHOST}/api/v1/company`;
